import * as THREE from 'three';

export function Disk(
    scene: THREE.Scene,
    x: number,
    z: number,
    size: number,
    color: number,
    borderColor: number
): void {
    const diskGeometry = new THREE.CylinderGeometry(size, size, 0.021, 64);
    const diskMaterial = new THREE.MeshBasicMaterial({ color: color });

    const diskBorderGeometry = new THREE.RingGeometry(size, size + 0.02, 64);
    const diskBorderMaterial = new THREE.MeshBasicMaterial({ color: borderColor });

    const disk = new THREE.Mesh(diskGeometry, diskMaterial);
    const diskBorder = new THREE.Mesh(diskBorderGeometry, diskBorderMaterial);

    diskBorder.rotation.x = -Math.PI / 2;
    diskBorder.position.set(0, 0.01, 0);

    const diskGroup = new THREE.Group();
    diskGroup.add(disk, diskBorder);
    diskGroup.position.set(x, 0, z);

    scene.add(diskGroup);
}